'use strict';

import Items from '../../../ui/Views/Announcements/FlexItems';
import Headers from '../../collections/headerList';
import { COLUMN_TYPES as CT } from '../../../consts';

const col = {};

col[CT.realtyType] = new Headers.HeaderItem();
col[CT.realtyType].addLabel('Тип', 'objectTypeId');

col[CT.area] = new Headers.HeaderItem();
col[CT.area].addLabel('Площадь', 'squareTotal');

col[CT.priceTotal] = new Headers.HeaderItem();
col[CT.priceTotal].addLabel('Цена', 'price');

col[CT.material] = new Headers.HeaderItem();
col[CT.material].addLabel('filler');

col[CT.pricePerMeter] = new Headers.HeaderItem();
col[CT.pricePerMeter].addLabel('Цена за м²', 'pricePerSquareMeter');

col[CT.date] = new Headers.HeaderItem();
col[CT.date].addLabel('Дата', 'inserted');

col[CT.priceAndPricePerMeter] = new Headers.HeaderItem();
col[CT.priceAndPricePerMeter]
    .addLabel('Цена', 'price')
    .addLabel('Цена за м²', 'pricePerSquareMeter');

col[CT.priceAndPay] = new Headers.HeaderItem();
col[CT.priceAndPay]
    .addLabel('Цена/Плата', 'price');

/** --- rent apartments */
const rentApartmentsColumns = [
  CT.realtyType,
  CT.priceAndPay,
  CT.area,
  CT.material,
  CT.date,
];

const rentApartmentsHeaders = new Headers.HeaderList();
rentApartmentsColumns.map(id => rentApartmentsHeaders.addHeader(col[id]));

/** --- rent commercials */
const rentCommercialsColumns = [
  CT.realtyType,
  CT.priceTotal,
  CT.area,
  CT.material,
  CT.date,
];
const rentCommercialsHeaders = new Headers.HeaderList();
rentCommercialsColumns.map(id => rentCommercialsHeaders.addHeader(col[id]));

/** --- rentDaily apartments */
const rentDailyApartmentsColumns = [
  CT.realtyType,
  CT.priceAndPay,
  CT.material,
  CT.date,
];
const rentDailyApartmentsHeaders = new Headers.HeaderList();
rentDailyApartmentsColumns.map(id => rentDailyApartmentsHeaders.addHeader(col[id]));

/** --- sale apartments */
const saleApartmentsColumns = [
  CT.realtyType,
  CT.priceAndPricePerMeter,
  CT.area,
  CT.material,
  CT.date,
];
const saleApartmentsHeaders = new Headers.HeaderList();
saleApartmentsColumns.map(id => saleApartmentsHeaders.addHeader(col[id]));

/** --- sale commercials */
const saleCommercialsColumns = [
  CT.realtyType,
  CT.priceTotal,
  CT.area,
  CT.material,
  CT.date,
];
const saleCommercialsHeaders = new Headers.HeaderList();
saleCommercialsColumns.map(id => saleCommercialsHeaders.addHeader(col[id]));

/** --- sale garages */
const saleGaragesColumns = [
  CT.realtyType,
  CT.priceTotal,
  CT.area,
  CT.material,
  CT.date,
];
const saleGaragesHeaders = new Headers.HeaderList();
saleGaragesColumns.map(id => saleGaragesHeaders.addHeader(col[id]));

/** --- sale lands */
const saleLandsColumns = [
  CT.realtyType,
  CT.priceTotal,
  CT.material,
  CT.material,
  CT.date,
];
const saleLandsHeaders = new Headers.HeaderList();
saleLandsColumns.map(id => saleLandsHeaders.addHeader(col[id]));

export function getHeaders (dealType, realtyType) {
  const section = `${dealType}_${realtyType}`;

  switch (section) {
    case 'rent_apartments': return rentApartmentsHeaders;
    case 'rent_commercials': return rentCommercialsHeaders;
    case 'rentDaily_apartments': return rentDailyApartmentsHeaders;

    case 'sale_apartments': return saleApartmentsHeaders;
    case 'sale_commercials': return saleCommercialsHeaders;
    case 'sale_garages': return saleGaragesHeaders;
    case 'sale_lands': return saleLandsHeaders;
  }
  return null;
}

export function getFlexItem (dealType, realtyType) {
  const section = `${dealType}_${realtyType}`;

  switch (section) {
    case 'rent_apartments': return Items.RentApartmentsFlexItem;
    case 'rent_commercials': return Items.RentCommercialsFlexItem;
    case 'rentDaily_apartments': return Items.RentDailyApartmentsFlexItem;

    case 'sale_apartments': return Items.SaleApartmentsFlexItem;
    case 'sale_commercials': return Items.SaleCommercialsFlexItem;
    case 'sale_garages': return Items.SaleGaragesFlexItem;
    case 'sale_lands': return Items.SaleLandsFlexItem;
  }
  return null;
}



// WEBPACK FOOTER //
// ./src/classes/builder/search/flexListBuilder.js